import styled from 'styled-components'

import { ratioToPercent, damperAngle, percentage } from 'helpers/formatters'

import { color } from 'styles/colors'

import React from 'react'

type Props = {
  fanStatusOn: boolean
  zoneSize: number
  className?: string
  damper: number
}

const Damper = ({ className, damper, fanStatusOn, zoneSize }: Props) => {
  const fanImage = fanStatusOn ? '/img/devices/fan-blades-anima.gif' : '/img/devices/fan-blades-static.png'

  return (
    <div {...{ className }}>
      <div>Damper {percentage(damper) || '--'}</div>
      <S.DamperBox>
        <S.Fan src={fanImage} alt="damper-fan" aria-label="fan" />
        <S.DamperBlade src="/img/devices/damper.png" alt="damper-blade" damperAngle={damperAngle(damper)} aria-label="damper blade" />
        <S.Icon aria-label="flow direction" className="icon-arrow-right4" />
      </S.DamperBox>
      <div>Zone Size {ratioToPercent(zoneSize) || '--'}</div>
    </div>
  )
}

export default Damper

const S = {
  DamperBox: styled.div`
    background: ${color('damperBackground')};
    height: 85px;
    width: 85px;
  `,
  Fan: styled.img`
    left: 2px;
    top: 1px;
    position: relative;
    width: 15px;
  `,
  DamperBlade: styled.img.withConfig({
    shouldForwardProp: (prop) => !['damperAngle'].includes(prop)
  })<{ damperAngle }>`
    display: block;
    position: relative;
    height: auto;
    max-width: 95%;
    top: 13px;
    transform: rotate(${({ damperAngle }) => damperAngle});
  `,
  Icon: styled.i`
    color: ${color('damperFloWDirection')};
    top: 25px;
    left: 2px;
    position: relative;
  `
}
